import React, {useEffect, useState} from "react";
import Card from "../../components/card";
import Container from "../../components/container";
import {Board} from "./styles";
import GeneralStatus from "../../components/general-status";
import IEnvironmentStatus from "../../interfaces/environment-status";
import { CircularProgress } from "@mui/material";
import { EnvironmentService } from "../../services/environment-service";
import { IEnvironment } from "../../models/environment";
import SearchComponent from "../../components/inputs/search-input";


const Dashboard = () => {
  const [environmentStatus, setEnvironmentsStatus] = useState<
    IEnvironmentStatus[]
  >([]);
  const [environments, setEnvironments] = useState<IEnvironment[]>([]);
  const [loading, setLoading] = useState(true);

  const [initialDate, setInitialDate] = React.useState<Date | null>(new Date(Date.now() - 864e5));
  const [finalDate, setFinalDate] = React.useState<Date | null>(new Date(Date.now()));
  const [environmentNameFilter, setEnvironmentNameFilter] = useState("");

  useEffect(() => {
    fetchEnvironments();
  }, []);

  useEffect(() => {
    const sortedEnvironments = [...environments].sort(
      (a, b) => sumEnvStatus(b) - sumEnvStatus(a)
    );
    setEnvironments(sortedEnvironments);
  }, [environmentStatus, environmentNameFilter]);

  async function fetchEnvironments() {
    setLoading(true);

    const environmentsFetched = await EnvironmentService.getAllEnvironments({
      page: 0,
      size: 100,
      sort: "id,name"
    }, {
      active: true
    });

    if (environmentsFetched) {
      setEnvironments(environmentsFetched.content);
    }

    setLoading(false);
  }

  function accentRemove(text: string | undefined): string {
    if (text) {
      return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    }
    return "";
  }

  function sumEnvStatus(environment: IEnvironment): number {
    const status = environmentStatus.find((e) => e.name === environment.name);

    if (!status) {
      return 9999999;
    }

    return (
      status.alerta * 500 +
      status.bloqueada * 10 +
      status.erro * 5000 +
      status.pendente +
      status.processando
    );
  }

  return (
    <>
      <GeneralStatus
        environmentStatus={environmentStatus}
        refreshAll={fetchEnvironments}
        loading={loading}
        finalDate={finalDate}
        initialDate={initialDate}
        setFinalDate={setFinalDate}
        setInitialDate={setInitialDate}
      />

      <SearchComponent onChange={setEnvironmentNameFilter} value={environmentNameFilter} environmentsLength={environments.length}/>

      <Container>
        <Board>
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            environments.map((e) => (
              <Card
                isVisible={accentRemove(e.name?.toLowerCase()).includes(accentRemove(environmentNameFilter.toLowerCase()))}
                key={e.name}
                environment={e}
                initialDate={initialDate}
                finalDate={finalDate}
                updateDashboardStatus={(status) =>
                  setEnvironmentsStatus((current) => [
                    ...current.filter((c) => c.name !== status.name),
                    status,
                  ])
                }
              />
            ))
          )}
        </Board>
      </Container>
    </>
  );
};

export default Dashboard;
